import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loan-btm-buttons',
  templateUrl: './loan-btm-buttons.component.html',
  styleUrl: './loan-btm-buttons.component.scss',
  standalone: false
})
export class LoanBtmButtonsComponent {
  @Input() prevTo?: () => void;
  @Input() nextTo?: () => void;
  @Input() submitTo?: () => void;
  /** Shown after user clicks Next/Submit while the step form is invalid; parent clears when form becomes valid. */
  @Input() showRequiredFieldsHint = false;
  @Input() requiredFieldsHintText = 'Please complete all required fields before continuing.';
}
